var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { defineStore } from "pinia";
import { FilterItemTypes } from "./types";
export var useFilterStore = defineStore('filterStore', {
    state: function () {
        return {
            config: {},
            values: {},
            instance: 0,
            active: false,
            enabled: true,
            loaded: false,
            items: [],
            sort: {
                type: 'hot',
                types: {},
            },
        };
    },
    actions: {
        disable: function () {
            this.enabled = false;
        },
        setLoaded: function (loaded) {
            if (loaded === void 0) { loaded = true; }
            this.loaded = loaded;
        },
        setInitialState: function (state) {
            this.config = state.config;
            this.setValues(state.values);
            this.active = Object.keys(state.values).length > 0;
        },
        setValues: function (values) {
            var e_1, _a, e_2, _b;
            var _c, _d;
            try {
                for (var _e = __values(this.items), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var item = _f.value;
                    var value = (_c = values[item.name]) === null || _c === void 0 ? void 0 : _c.split('-');
                    if ((_d = values[item.name]) === null || _d === void 0 ? void 0 : _d.match(/^[\d-]+$/)) {
                        value = value.map(function (v) { return parseInt(v); });
                    }
                    if (item.type === FilterItemTypes.List || item.type === FilterItemTypes.FilterableList) {
                        item.active = !!(value === null || value === void 0 ? void 0 : value.length);
                        try {
                            for (var _g = (e_2 = void 0, __values(item.options)), _h = _g.next(); !_h.done; _h = _g.next()) {
                                var option = _h.value;
                                option.selected = !!(value === null || value === void 0 ? void 0 : value.includes(option.value));
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                    }
                    else if (item.type === FilterItemTypes.Flag) {
                        item.active = value !== undefined;
                    }
                    else if (item.type === FilterItemTypes.Range) {
                        if (value === null || value === void 0 ? void 0 : value.length) {
                            var _j = __read(value, 2), min = _j[0], max = _j[1];
                            item.active = true;
                            item.value.min = parseInt(min);
                            item.value.max = parseInt(max);
                        }
                        else {
                            item.active = false;
                        }
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
                }
                finally { if (e_1) throw e_1.error; }
            }
            var firstActiveItem = this.items.find(function (i) { return i.active; });
            if (firstActiveItem) {
                firstActiveItem.expanded = true;
            }
        },
        update: function (items) {
            this.items = items;
            if (!items.length) {
                this.disable();
            }
        },
        updateValues: function () {
            var e_3, _a, e_4, _b;
            var values = {};
            try {
                for (var _c = __values(this.items), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var item = _d.value;
                    if (item.type === FilterItemTypes.List || item.type === FilterItemTypes.FilterableList) {
                        var options = [];
                        try {
                            for (var _e = (e_4 = void 0, __values(item.options)), _f = _e.next(); !_f.done; _f = _e.next()) {
                                var option = _f.value;
                                if (option.selected) {
                                    options.push(option.value);
                                }
                            }
                        }
                        catch (e_4_1) { e_4 = { error: e_4_1 }; }
                        finally {
                            try {
                                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                            }
                            finally { if (e_4) throw e_4.error; }
                        }
                        if (options.length) {
                            values[item.name] = options.join('-');
                            item.active = true;
                        }
                        else {
                            item.active = false;
                        }
                    }
                    if (item.type === FilterItemTypes.Flag) {
                        if (item.active) {
                            values[item.name] = true;
                        }
                    }
                    if (item.type === FilterItemTypes.Range) {
                        if (item.value.min === item.available.min && item.value.max === item.available.max) {
                            item.active = false;
                            continue;
                        }
                        if (item.value.min === 0 && item.value.max === 0) {
                            item.active = false;
                            continue;
                        }
                        values[item.name] = "".concat(item.value.min, "-").concat(item.value.max);
                        item.active = true;
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_3) throw e_3.error; }
            }
            this.values = values;
            this.active = Object.keys(values).length > 0;
        },
        setSortType: function (sort) {
            this.sort.type = sort;
            this.config.sort = sort;
        },
        setSortTypes: function (sort) {
            this.sort.types = sort;
        },
    }
});
